exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-7b2a1b6c] {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.foot[data-v-7b2a1b6c] {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 10px;\n}\n", ""]);

// exports
